module.exports = __webpack_public_path__ + "img/repair-and-maintenatce.3640c94e.svg";